var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[(_vm.url)?_c('iframe',{attrs:{"id":"iframe","src":_vm.url,"width":"100%","height":"100%","frameborder":"0","marginWidth":"0px","marginHeight":"0px","scrolling":"yes","seamless":""}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }